"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isolateTree = exports.filterTree = exports.initialTocTree = exports.findStart = exports.removeAtDepth = exports.findFirstTopicRef = void 0;
//DFS of the structure to find the first topicRef that we see.
var findFirstTopicRef = function (next, checkView) {
    var _a;
    if (checkView === void 0) { checkView = true; }
    var stop = !next || (checkView && ((_a = next.outputclasses) === null || _a === void 0 ? void 0 : _a.includes("view-tiles")));
    if (stop)
        return next;
    var isTopic = next.type === "topicref";
    var isVersion = next.type === "version";
    var noChildren = !next.children || !next.children.length;
    if (isTopic || isVersion || noChildren)
        return next;
    for (var i = 0; i < next.children.length; i++) {
        var nextChildNode = next.children[i];
        if (nextChildNode.type === "topicref") {
            return nextChildNode;
        }
        else {
            var possibleNode = exports.findFirstTopicRef(nextChildNode);
            if (possibleNode.type === "topicref") {
                return possibleNode;
            }
        }
    }
    return next;
};
exports.findFirstTopicRef = findFirstTopicRef;
var removeAtDepth = function (node, target, currentDepth) {
    if (currentDepth === void 0) { currentDepth = 0; }
    if (target === currentDepth) {
        node.children = [];
    }
    else if (node && node.children) {
        node.children = node.children.map(function (child) { return exports.removeAtDepth(child, target, currentDepth + 1); });
    }
    return node;
};
exports.removeAtDepth = removeAtDepth;
//DFS of the structure to find the given href.
var findStart = function (next, reference, key) {
    if (key === void 0) { key = "href"; }
    if (next && next[key] === reference) {
        return next;
    }
    if (!next || !next.children)
        return;
    for (var i = 0; i < next.children.length; i++) {
        var nextChildRef = exports.findStart(next.children[i], reference, key);
        if (nextChildRef) {
            return nextChildRef;
        }
    }
};
exports.findStart = findStart;
var initialTocTree = function (root, contentPath) {
    root.children = root.children.map(function (c) {
        var filteredNode = exports.isolateTree(c, contentPath, "href");
        if (filteredNode) {
            return filteredNode;
        }
        else {
            c.children = [];
            return c;
        }
    });
    return root;
};
exports.initialTocTree = initialTocTree;
var filterTree = function (root, val, prop) {
    var _a;
    if (!val) {
        return root;
    }
    if (typeof (val) === "string") {
        val = new RegExp(val, 'i');
    }
    var newChildren = [];
    if ((_a = root.children) === null || _a === void 0 ? void 0 : _a.length) {
        for (var i = 0; i < root.children.length; i++) {
            var nextChildNode = root.children[i];
            nextChildNode = exports.filterTree(nextChildNode, val, prop);
            if (nextChildNode) {
                newChildren.push(nextChildNode);
            }
        }
    }
    if (newChildren.length || val.test(root[prop])) {
        return __assign(__assign({}, root), { children: newChildren });
    }
    else {
        return null;
    }
};
exports.filterTree = filterTree;
var isolateTree = function (root, val, prop) {
    var _a;
    if (!val) {
        return root;
    }
    if (typeof (val) === "string") {
        val = new RegExp(val, 'i');
    }
    var newChildren = [];
    if ((_a = root.children) === null || _a === void 0 ? void 0 : _a.length) {
        root.hasChildren = true;
        for (var i = 0; i < root.children.length; i++) {
            var nextChildNode = root.children[i];
            nextChildNode = exports.filterTree(nextChildNode, val, prop);
            if (nextChildNode) {
                if (nextChildNode.isTail) {
                    newChildren = root.children;
                    break;
                }
                else {
                    newChildren.push(nextChildNode);
                }
            }
        }
    }
    var onPath = (root && root[prop] && root[prop].indexOf(val) !== -1);
    if (newChildren.length || onPath) {
        var isTail = (root[prop] === val);
        return __assign(__assign({}, root), { isTail: isTail, children: newChildren });
    }
    else {
        return null;
    }
};
exports.isolateTree = isolateTree;
